//import ReactToPdf from "react-to-pdf";
import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import Moment from "moment";
import logo from "./images/loading.gif";
import logoverified from "./images/verified.png";
//import ModalLogin from './ModalLogin';
import Mymodal from './modal';
import config from '../config';
import logoload from "./images/loader.gif";
import BusyModal from "./modalwait";
//import Modal from "react-bootstrap/Modal"

import paidimage from "./images/paid.jpg";

//import { position } from "html2canvas/dist/types/css/property-descriptors/position";
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class MedicalFormEdit extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{PCode: "", PName: "", relation:"Self", cAmt:0, cDate:"", mAmt:0, mDate:"", tAmt:0, tDate:""},
            myitems: [],
            isLoaded: false,
            isForm: "none",
            FormID:"",
            errortext:"",

            errortextb:"",

            errorcss:"",
            remaincolor:"",
            paidlogo:"",
            modalbody:"wait please...",
            modaltitle:"",
            modalfooter:"",
            isOpen:false,
            editED:false,saveED:false,
            GAmt:0,
            AGAmt:0,
            BAmount:0,
            BAmount2:0,
            buttonED:false,
            modalbody:config.gvr.mymodal.loadwait,
            modalimage:logoload,
            
            divbutton:"<button onClick={this.handleVerify(0)} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}}>Check / Verify</button>",
            ErrMsg:<img src={logo} alt=""/>,
            ErrMsg2:""
        }
        this.currencyFormat = this.currencyFormat.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
//        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleUpdateForm = this.handleUpdateForm.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleAddClick = this.handleAddClick.bind(this);
        this.handleInputChange2 = this.handleInputChange2.bind(this);
        this.handleInputChange22 = this.handleInputChange22.bind(this);

    }
  // handle click event of the Add button
  handleAddClick=()=>{
    let input=this.state.input;  
    let mitem = this.state.myitems;
    mitem.push({ Ceiling:0,ClaimID:this.state.FormID, Const_amt:input["cAmt"], Const_date:input["cDate"], DESIG:"",DateClaim:input["DateClaim"],Emp_Id:input["Emp_ID"],Med_amt:input["mAmt"], Med_date:input["mDate"],Name:"",PName:input["PName"],Relation:input["relation"],Test_amt:input["tAmt"],Test_date:input["tDate"],id:0,Location:"",status:0});
    this.setState({myitems:mitem,saveED:false});
    this.setState({CAmt:0,TAmt:0,MAmt:0});
//    console.log(this.state.myitems);
  }

    showModal=()=>
    {
        this.setState({isOpen:true});
    }
    hideModal=()=>
    {
        this.setState({isOpen:false});
    }

    handleEditClick(){
        this.setState({editED:true,saveED:false});
    }
    // handle input change
    handleInputEdit=(e, index)=>{

        let myitems = this.state.myitems;
        myitems[index][e.target.name] = e.target.value;
        this.setState({myitems});
    }
    handleInputEditAmt1=(e, index)=>{    
        this.setState({BAmount:Number(this.state.BAmount) + Number(e.target.value)})
    }
 
    handleInputEditAmt=(e, index)=>{        
//        let input = this.state.input;
/*        let rcolor = "";
        input["Remaining"]=input["Remaining"]-Number(e.target.value)+this.state.p_amt;
        if(Number(input["Remaining"]) < 0)
            rcolor="red";
        else
            rcolor="";*/
        this.handleInputEdit(e, index);
//        this.setState({input,remaincolor:rcolor});

    }
    
  handleInputChange(e){
    this.setState({FormID:e.target.value});
  }
  handleInputChange2(e){
    let input=this.state.input;
    input[e.target.name]= e.target.value;
    this.setState({input});
  }
  handleInputChange22(e){
    let input=this.state.input;
    input[e.target.name]= e.target.value;

    this.setState({input,BAmount2:Number(this.state.BAmount2)+Number(e.target.value)});
  }

  handleFocus=(e)=>{
      e.target.select();
      this.setState({BAmount:Number(this.state.BAmount) - Number(e.target.value)});

      this.setState({p_amt:Number(e.target.value)});
    }
    handleFocus2=(e)=>{
        e.target.select();
        this.setState({BAmount2:Number(this.state.BAmount2) - Number(e.target.value)});
  
        this.setState({p_amt:Number(e.target.value)});
      }
  
  handleUpdateForm(){

    document.body.style.cursor="wait";

    this.setState({ErrMsg2:<BusyModal/>});

    axios({
      method: 'post',
      url: cookies.get("phpclass")+'/index.php/user/updatemedicaldetail/',
      data: this.state.myitems,
      headers: {'Content-Type': 'multipart/form-data'}
    })
    .then((response)=> {
     document.body.style.cursor="default";
     if(response.data==="1")
     { 
            this.setState({ErrMsg2:"",errortextb:"Update has been made successfully",errorcss:"labelsave",editED:false,saveED:true});
//            this.setState({error:"Update has been made successfully",editED:false,saveED:true});
     } 
     else
     {   
           this.setState({ErrMsg2:"",errortextb:"Some Error accoured, please try later",errorcss:"labelerror"});
     }
    })
    .catch(function (response) {
         document.body.style.cursor="default";
         this.setState({ErrMsg2:"",errortextb:"Some Error accoured, please try later",errorcss:"labelerror"});

    });
 }

  handleVerify(){
        document.body.style.cursor="wait";
        this.setState({buttonED:true});
        axios({
            method: "post",
            url:    cookies.get("phpclass")+"/index.php/user/approveMedical/"+this.state.FormID,
            heaer: {"Content-Type":"multipart/for-data"}
        })
        .then((response)=>{
            document.body.style.cursor="default";
            this.setState({buttonED:true,divbutton:<img src={logoverified}/>});

        })
        .catch=()=>{
            document.body.style.cursor="default";
            this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});

        };
  }

    currencyFormat(num) {
        let cnum=Number(num);
            return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
     }
/*    handleSubmit(){*/
    componentDidMount()
    {
        this.setState({CAmt:0,TAmt:0,MAmt:0});
        let functionpath="";
        if(typeof this.props.location.data !== "undefined")
        { 
            let claimid = this.props.location.data["ClaimID"];           
            this.setState({errortext:"",BAmount:Number(this.props.location.data["BillAmt"])});
            if(this.props.location.data["st"]==="P")
            {
                functionpath =cookies.get("phpclass")+'/index.php/user/AdminmedicalFormPrevious/'+claimid
            }
            else
                functionpath =cookies.get("phpclass")+'/index.php/user/AdminmedicalForm/'+claimid

            document.body.style.cursor="wait";
            axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/AdminmedicalForm/'+claimid,
                url: functionpath,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                if(response.data.length == 0)
                {
                    this.setState({errortext:"Invalid Form ID"});
                    document.body.style.cursor="default";            
                }
                else
                {
                    document.body.style.cursor="default";
                    let input = this.state.input;
                    input["Name"] = response.data[0]["NAME"];
                    input["Designation"] = response.data[0]["DESIG"];
                    input["Emp_ID"] = response.data[0]["Emp_Id"];
                    input["Location"] = response.data[0]["location"];
                    input["DateClaim"] = response.data[0]["DateClaim"];
                    input["ClaimID"] = claimid;
                    input["Ceiling"] = response.data[0]["Ceiling"];
                    input["Remaining"] = response.data[0]["Remaining"];
                    input["myear"] = response.data[0]["myear"];

                    this.setState({input, isLoaded: true, isForm:"none", myitems: response.data, ErrMsgs:"",buttonED: false});
                    if(response.data[0]['status'] === 1)
                        this.setState({paidlogo:paidimage,editED:true,saveED:true, divbutton:<span style={{fontSize:'12pt',color:'red'}}>This claim has already been paid.</span>});
                    else
                        this.setState({paidlogo:"",editED:false,saveED:true,divbutton:<button onClick={this.handleVerify} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}} disabled={this.state.buttonED}>Check / Verify</button>});
                }
            })
            .catch=()=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            }; 
        }
        else
        {
            this.props.history.push({pathname: '/MedicalClaimList'});
        }            
    }
    render(){
        let items=this.state.myitems;
        let Const_date,Med_date,Test_date = "";
        let CAmt = this.state.CAmt;
        let MAmt = this.state.MAmt;
        let TAmt = this.state.TAmt;
        let RowAmt = this.state.RowAmt;
        let GAmt = this.state.GAmt;
//        let isForm = this.state.isForm;
        let isLoaded = this.state.isLoaded;
        if(isLoaded)
        {

            return(
                <div className="container1">
               <div width="100%" Align="center"  >                  
               <br></br>
                <div className="inner-div"  >
                    <div width="100%">
                    <h5>Medical Reimbursement Form</h5>
                    <br></br>
                    <div style={{textAlign:"left",width:"60%",paddingLeft:"55px",float:"left"}}>
                        <table className="mtable">
                            <tbody>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Claim ID:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.state.input["ClaimID"]}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Employee's ID:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Emp_ID"]}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Employee's Name:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Name"]}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Designation:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Designation"]}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Location:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.state.input["Location"]}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Date:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{Moment(this.state.input["DateClaim"]).format("DD/MM/YYYY")}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Ceiling:</td>
                                <td style={{width:"300px",textAlign:"left"}}>{this.currencyFormat(this.state.input["Ceiling"])}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Remaining:</td>
                                <td style={{width:"300px",textAlign:"left", color:this.state.remaincolor}}>{this.currencyFormat(this.state.input["Remaining"])}</td>
                            </tr>
                            <tr>
                                <td style={{width:"200px",fontStyle: "normal"}}>Bill Amount:</td>
                                <td style={{width:"300px",textAlign:"left", color:this.state.remaincolor}}>{this.currencyFormat(this.state.BAmount)}</td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                    <div style={{width:"40%", float:"left"}}>
                            <img src={this.state.paidlogo} />
                        </div>
                    </div>
                    <table className="mtable">
                        <thead >
                            <tr>
                            <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>PATIENT NAME</p></th>
                            <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                            <th className="mth" colSpan="2"><p style={{textAlign:'center'}}> CONSULTATION</p></th>
                            <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                            <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
                            <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>TOTAL.</p></th>
                            </tr> 
                            <tr>
                            <th className="mth">Amount</th>
                            <th className="mth">Date</th>
                            <th className="mth">Amount</th>
                            <th className="mth">Date</th>
                            <th className="mth">Amount</th>
                            <th className="mth">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((x, i) => {
                            CAmt += Number(x.Const_amt);
                            TAmt += Number(x.Test_amt);
                            MAmt += Number(x.Med_amt);
                            RowAmt = Number(x.Const_amt)+Number(x.Test_amt)+Number(x.Med_amt);
                            GAmt += Number(RowAmt); // this.state.CAmt+this.state.TAmt+this.state.MAmt                      
                            if(Number(x.Const_amt) === 0) 
                                Const_date= "";
                            else
                                Const_date=  x.Const_date; //.format("DD/MM/YYYY")
                            if(Number(x.Med_amt) === 0) 
                                Med_date= "";
                            else
                                Med_date=x.Med_date; // Moment(x.Med_Date).format("DD/MM/YYYY")
                            if(Number(x.Test_amt) === 0) 
                                Test_date= "";
                            else
                                Test_date=x.Test_date; //).format("DD/MM/YYYY")
                            return(
                                    <tr key={i} height="40px">
                                        <td className="mtd" width="165px" >
                                        <input style={{width:175, border:'none'}} value={x.PName} readOnly disabled={this.state.editED}></input>
                                            {/*<span width="175px">{x.PName}</span>*/}
                                        </td>
                                        <td className="mtd" width="80px">
                                        <input style={{width:75, border:'none'}} value={x.Relation} readOnly disabled={this.state.editED}/>
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:65, border:'none',textAlign: 'right' }}
                                            name="Const_amt"
                                            disabled={this.state.saveED}
                                            value={Number(x.Const_amt)}
                                            onChange={e=> this.handleInputEditAmt(e,i)}
                                            onBlur={e=> this.handleInputEditAmt1(e,i)}
                                            onFocus={this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:120, border:'none'}}
                                            disabled={this.state.saveED}
                                            name="Const_date"
                                            value={Const_date}
                                            onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:65, border:'none',textAlign: 'right' }}
                                            name="Med_amt"
                                            disabled={this.state.saveED}
                                            value={Number(x.Med_amt)}
                                            onChange={e=> this.handleInputEditAmt(e,i)}
                                            onBlur={e=> this.handleInputEditAmt1(e,i)}
                                            onFocus={ this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:120, border:'none'}}
                                            disabled={this.state.saveED}
                                            name="Med_date"
                                            value={Med_date}
                                            onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="number" style={{width:65, border:'none',textAlign: 'right' }}
                                            disabled={this.state.saveED}
                                            name="Test_amt"
                                            value={Number(x.Test_amt)}
                                            onChange={e=> this.handleInputEditAmt(e,i)}
                                            onBlur={e=> this.handleInputEditAmt1(e,i)}
                                            onFocus={ this.handleFocus}
                                            />
                                        </td>
                                        <td className="mtd" >
                                            <input type="date" style={{width:120, border:'none'}}
                                            disabled={this.state.saveED}
                                            name="Test_date"
                                            value={Test_date}
                                            onChange={e=> this.handleInputEdit(e,i)}
                                            />
                                        </td>
                                        <td className="mtd">
                                        <input type="text" style={{width:65, border:'none',textAlign:"right"}}
                                            disabled
                                            value={this.currencyFormat(RowAmt)}
                                        />
                                        </td>
                                    </tr>
                                );
                            })}  

                            <tr style={{height:"40px", border: "1.5px solid rgb(161, 159, 159, 161)"}}>
                            <td className="mtdleft2" colSpan="2">
                                TOTAL
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(CAmt)}                
                            </td>
                            <td className="mtdcenter2" colSpan="2" >
                                {this.currencyFormat(MAmt)}
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(TAmt)}
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(GAmt)}
                            </td>

                        </tr>

                        </tbody>
                    </table>
                    <div style={{width:"90%", height:"40px",textAlign:"center", marginTop:"5px"}} >
                    <button style={{marginRight:"5px",align:"center",width:"75px"}} className="btn btn-secondary"  disabled={this.state.editED} onClick={this.handleEditClick}>Edit</button>

                      <button  style={{margingLeft:"5px",align:"center",width:"75px"}} className="btn btn-secondary"  disabled={this.state.saveED} onClick={this.handleUpdateForm}>Save</button>

                    </div>

                <br></br>
                <table className="mtable">
                <thead>
                 </thead>
                <tbody>
                <tr >
                    <td className="mtd" width="165px">
                        <input style={{width:165, border:'none'}}
                        autoFocus="autofocus"
                        name="PName"
		        	    placeholder="Patient Name"
                        onChange={e =>this.handleInputChange2(e)}
                         onFocus={this.handleFocus}
                        />
                    </td>
                    <td className="mtd" width="80">
                        <select style={{width:80, border:'none'}}
    //                    value={x.relation} 
                        name="relation"
                        onChange={e => this.handleInputChange2(e)}
                        >
                            <option value="Self">Self</option>
                            <option value="Wife">Wife</option>
                            <option value="Daughter">Daughter</option>
                            <option value="Son">Son</option>
                        </select>
                    </td>
                    <td className="mtd" width="65">
                        <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                            name="cAmt"
                            onChange={e => this.handleInputChange2(e)}
                            onBlur={e => this.handleInputChange22(e)}

                            onFocus={ e => this.handleFocus2(e)}
                        />
                    </td>
                    <td className="mtd" width="120">
                        <input type="date" style={{width:120, border:'none'}}
                            name="cDate"
                            onChange={e => this.handleInputChange2(e)}
                        />
                    </td>
                    <td className="mtd" width="65">
                        <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                            name="mAmt"
                            onChange={e => this.handleInputChange2(e)}
                            onBlur={e => this.handleInputChange22(e)}
                            onFocus={ e => this.handleFocus2(e)}
                            />
                    </td>
                    <td className="mtd" width="120">
                        <input type="date" style={{width:120, border:'none'}}
                            name="mDate"
                            onChange={e => this.handleInputChange2(e)}
                        />
                    </td>
                    <td className="mtd" width="65">
                        <input type="number" style={{width:75, border:'none',textAlign: 'right' }}
                            name="tAmt"
                            onChange={e => this.handleInputChange2(e)}
                            onBlur={e => this.handleInputChange22(e)}
                            onFocus={ e => this.handleFocus2(e)}
                        />
                    </td>
                    <td className="mtd" width="120">
                        <input type="date" style={{width:120, border:'none'}}
                            name="tDate"
                            onChange={e => this.handleInputChange2(e)}
                        />
                    </td>
                    <td  width="65" >
                        <button onClick={this.handleAddClick}>+</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <div style={{width:"100%",float:"center",textAlign:"center"}}>
            <span className={this.state.errorcss}><b>{this.state.errortextb}</b></span>
        </div>
        </div>
        </div>
        {this.state.ErrMsg2}

        </div>
        );
    
    } 
    else
    {
        return(
            <div className="container1">
            <div className="center">
                {this.state.ErrMsg}
            </div>
            </div>
        );
    }
}   /* End Render}*/
}
